export function setDarkMode(dark: boolean) {
    window.localStorage.setItem("wavy.dark-mode", dark ? "1" : "0");
    window.location.reload();
}

export function isDarkMode() {
    return window.localStorage.getItem("wavy.dark-mode") === "1";
}
